import { tokenRefreshManager } from "@/lib/tokenRefresh";
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AuthMiddleware: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isValidating, setIsValidating] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const validateAuth = async () => {
      try {
        const token = await tokenRefreshManager.getValidAccessToken();

        if (token) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Auth validation error:", error);
        setIsAuthenticated(false);
      } finally {
        setIsValidating(false);
      }
    };

    validateAuth();
  }, []);

  if (isValidating || isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <p className="mt-2 text-sm text-muted-foreground">Validating session...</p>
        </div>
      </div>
    );
  }

  const loginUrl = `/login?redirectTo=${encodeURIComponent(location.pathname + location.search)}`;
  return isAuthenticated ? <Outlet /> : <Navigate to={loginUrl} replace />;
};

export default AuthMiddleware;
